define('modules/integrations/services/zapier/view',['require','exports','module','views/BaseView','./zapierHelper','env','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView"),
    ZapierHelper = require("./zapierHelper"),
    Config = require("env");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),

    initialize: function () {
      var currentGroupId =
        this.group.get("selectedCompany") || this.group.get("id");
    },

    beforeRender: function () {},

    afterRender: function () {
      ZapierHelper.addScript();
      ZapierHelper.addStyles();

      var element = ZapierHelper.getElement();
      var $container = $("#zapier-container");

      $container.html(element);
    },

    serialize: function () {
      return {
        mdirectorPreferencesUrl:
          Config.mdirectorUrl +
          "/private#preferences" +
          Config.getCompanyIdForUrl("&"),
      };
    },
  });

  module.exports = Layout;
});

